import { useQuery } from 'react-query';
import { getLMSTechStackById, getLMSTechStacks, GetLMSTechStacksAPIResponse, GetLMSTechStackByIdAPIResponse } from 'src/apis/dropdownMenu';

export const useGetLMSTechStacksQuery = (onComplete?: (data: GetLMSTechStacksAPIResponse) => void, isActive?: boolean, category?: string, showInMenu?: boolean) => {
	return useQuery({
		queryKey: ['getLMSTechStacks', isActive, category, showInMenu],
		queryFn: async () => (await getLMSTechStacks(isActive, category, showInMenu)) as GetLMSTechStacksAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};

/**
 * Reusable hook for fetching dropdown menu items by category
 * @param category - The category to filter by (e.g., 'LMS_TECHSTACK', 'SUB_ROLE')
 * @param showInMenu - If true, only return items where showInMenu is true. If false/undefined, return all active items
 * @param isActive - Filter by active status (default: true)
 * @param usePublicRoute - If true, use public route (for jobseekers accessing support ticket categories)
 */
export const useGetDropdownItemsByCategory = (category: string, showInMenu?: boolean, isActive: boolean = true, usePublicRoute?: boolean) => {
	return useQuery({
		queryKey: ['getDropdownItemsByCategory', category, showInMenu, isActive, usePublicRoute],
		queryFn: async () => (await getLMSTechStacks(isActive, category, showInMenu, usePublicRoute)) as GetLMSTechStacksAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
	});
};

export const useGetLMSTechStackById = (id?: string) => {
	return useQuery({
		queryKey: ['getLMSTechStackById', id],
		queryFn: async () => (await getLMSTechStackById(id ?? '')) as GetLMSTechStackByIdAPIResponse,
		staleTime: 0,
		enabled: !!id,
		refetchOnMount: true,
	});
};
